module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty7.d8d21793.jpg";